import React from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";

export const readPurchasingReportConfig = (definition) => {
  const config = definition?.config_json || definition?.config || {};
  const ui = config?.ui || definition?.ui || {};
  return {
    filters: ui.filters ?? null,
    visibleCols: ui.visibleCols ?? null,
    pinned: config?.pinned ?? ui?.pinned ?? false,
  };
};

const sameJsonValue = (left, right) => JSON.stringify(left ?? null) === JSON.stringify(right ?? null);

export const doesPinnedReportMatchState = (definition, appliedFilters, visibleCols) => {
  const saved = readPurchasingReportConfig(definition);
  if (!saved.filters || !sameJsonValue(saved.filters, appliedFilters)) return false;
  return !saved.visibleCols || sameJsonValue(saved.visibleCols, visibleCols);
};

const PinnedReportQuickSelect = ({ reports = [], activeReportId = null, onSelect, textMuted }) => {
  if (!reports.length) return null;

  return (
    <Box sx={{ width: "100%", px: 2, pt: 1.5, pb: 0.5, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
      <Typography variant="caption" sx={{ color: textMuted, fontWeight: 600, fontSize: "0.7rem", textTransform: "uppercase", mr: 0.5 }}>
        Saved:
      </Typography>
      {reports.map((definition) => {
        const active = String(definition.id) === String(activeReportId);
        return (
          <Tooltip key={definition.id} title={definition.description || definition.name} arrow>
            <Chip
              icon={<BuildIcon sx={{ fontSize: "14px!important" }} />}
              label={definition.name}
              color={active ? "primary" : "default"}
              variant={active ? "filled" : "outlined"}
              size="small"
              clickable
              aria-pressed={active}
              data-active={active ? "true" : "false"}
              onClick={() => onSelect(definition)}
              sx={{
                fontSize: "0.78rem",
                height: 26,
                borderRadius: "6px",
                borderWidth: active ? 2 : 1,
                boxShadow: active ? "0 0 0 2px rgba(59,130,246,0.16)" : "none",
                "&:hover": { borderColor: "#3b82f6", color: active ? undefined : "#3b82f6" },
              }}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default PinnedReportQuickSelect;
